import { differenceInSeconds } from "date-fns";

// Start prompting a reconnect this many days before an integration's
// refresh token expires. Mirrors the widest bucket in the backend's
// warn-thresholds (audiences/components/integration.rkt), which drives the
// warning emails -- keep the two in step so the UI and the email agree.
export const EXPIRY_WARNING_DAYS = 30;

// Null when the integration reports no expiry, which is every provider but
// LinkedIn today. Zero or less only once the token is genuinely dead.
//
// Rounds elapsed time up rather than counting calendar boundaries, matching
// days-until on the backend: a token with 18 hours left is "1 day", not the
// "0 days" a calendar-day count returns when the expiry lands later today.
// The email and this page report the same number as a result.
export function daysUntilExpiry(expiresAt: string | null): number | null {
  if (!expiresAt) return null;
  const seconds = differenceInSeconds(new Date(expiresAt), new Date());
  if (Number.isNaN(seconds)) return null;
  return Math.ceil(seconds / 86400);
}
